export default "__VITE_PUBLIC_ASSET__aa11ea9c__"